import { NbnAccountsResponse } from '@aglenergy/shared-library';
import { ReportErrorType, ResponseError } from 'app/shared/models/index';
import { store } from 'app/shared/store/store';
import { configService } from 'app/shared/services/config/config.service';
import { errorReportingService } from 'app/shared/services/error-reporting/error-reporting.service';

class AccountApiService {
  private apiBaseURL: string;
  private apimSubscriptionKey: string;

  private getConfig() {
    if (!this.apiBaseURL && !this.apimSubscriptionKey) {
      const configData = store.get('configData');
      this.apiBaseURL = configData.bffApiUrl;
      this.apimSubscriptionKey = configData.bffOcpApimSubscriptionKey;
    }
  }
  public async getMobileAccountServices(): Promise<NbnAccountsResponse> {
    this.getConfig();
    const httpHeaders = configService.getHttpHeaders(false);

    const requestUrl = `${this.apiBaseURL}/mobile/accounts`;

    const init = {
      method: 'GET',
      headers: httpHeaders
    };

    return await fetch(requestUrl, init)
      .then((response: Response) => {
        return this.processNbnAcccountsResponse(response);
      })
      .catch((error) => {
        throw new ResponseError(error.message, error.errorType);
      });
  }

  private processNbnAcccountsResponse = (response: Response): Promise<NbnAccountsResponse> => {
    if (!response.ok) {
      errorReportingService.logError('Unable to retrieve accounts from SPC', ReportErrorType.SPCAccountsFailed);
      throw new ResponseError(response.statusText, 'systemError');
    }
    return response.json();
  };
}

export const accountApiService = new AccountApiService();
